import React, { ReactElement } from 'react';
import VoxelText from '../../Text/VoxelText';
import VoxelPanel from '../VoxelPanel';

export interface VoxelFormPanelProps {
  title: ReactElement;
  subtitle?: ReactElement;
  disabled?: boolean;
}

export const VoxelFormPanel: React.FC<VoxelFormPanelProps> = ({
  children,
  title,
  subtitle,
  disabled
}) => {
  return (
    <VoxelPanel className=''>
      <div className={`pt-6 px-6 ${disabled ? 'opacity-60' : ''}`}>
        <VoxelText variant="title2" >
          {title}
        </VoxelText>
        <VoxelText paddingTop>{subtitle}</VoxelText>
      </div>
      {children}
    </VoxelPanel>
  );
};

export default VoxelFormPanel;
